import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-411e1d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pv"
}
const _hoisted_2 = { class: "pv__elm" }
const _hoisted_3 = { class: "pv__elm-backward" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pv__elm-backward-label" }, "Оплата", -1))
const _hoisted_5 = {
  key: 0,
  class: "pv__elm-transaction-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_FormPayment = _resolveComponent("FormPayment")!
  const _component_PaymentHistory = _resolveComponent("PaymentHistory")!

  return (_ctx.tariffType !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.device.isMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "pv__elm-backward-link",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickRedirect('instances')))
                }, [
                  _createVNode(_component_IconArrowLeft, { color: "rgb(49, 49, 50)" })
                ]))
              : _createCommentVNode("", true),
            _hoisted_4
          ]),
          _createVNode(_component_FormPayment, { onIsBalance: _ctx.onIsBalance }, null, 8, ["onIsBalance"]),
          (_ctx.isPayHistory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " История транзакций "))
            : _createCommentVNode("", true),
          _createVNode(_component_PaymentHistory, { class: "pv__elm-transaction-history" })
        ]),
        _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.tariffType), 513), [
          [_vShow, false]
        ])
      ]))
    : _createCommentVNode("", true)
}